import React from 'react';
import { Shield, Check } from 'lucide-react';
import { motion } from 'framer-motion';

const PrivacyBadge = ({ variant = 'default' }) => {
  if (variant === 'small') {
    return (
      <div className="inline-flex items-center gap-1.5 px-2 py-1 bg-verify/10 border border-verify/20 rounded-md" data-testid="privacy-badge-small">
        <Shield className="w-3 h-3 text-verify" />
        <span className="text-xs font-medium text-verify">Privacy Mode</span>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-verify/5 border border-verify/20 rounded-lg p-4" data-testid="privacy-badge"
    >
      <div className="flex items-start gap-3">
        <div className="bg-verify/10 p-2 rounded-md">
          <Shield className="w-5 h-5 text-verify" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-public font-semibold text-slate-900">Privacy Mode Active</h4>
            <Check className="w-4 h-4 text-verify" />
          </div>
          <p className="text-sm text-slate-600">
            Your file is automatically anonymized and deleted after processing.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default PrivacyBadge;
